import { Shield } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ShieldIcon = createLucideIcon(Shield);
